module.exports = __webpack_public_path__ + "img/magic-chilled.2bab1f04.png";